const sortingOptions = ['default', 'ascending', 'descending'];

export function getSortingOption(prevSort) {
  const sortIndex = sortingOptions.indexOf(prevSort) + 1;
  return sortingOptions[sortIndex === sortingOptions.length ? 0 : sortIndex];
}

export function getUuidsSortedItems(items) {
  if (!items) return [];
  const parentItems = items.filter(({ parentUuid }) => parentUuid === null);
  const sortedItems = Array.from(parentItems);
  parentItems.forEach(item => {
    if (items.some(({ parentUuid }) => parentUuid === item.uuid)) {
      const itemIndex = sortedItems.indexOf(item);
      sortedItems.splice(itemIndex + 1, 0, ...items.filter(({ parentUuid }) => parentUuid === item.uuid));
    }
  });
  return sortedItems.map(({ uuid }) => uuid);
}
